module.exports = __webpack_public_path__ + "img/alertWardInfoYellow.4c4ae85a.svg";